import { AppRouteProps } from "@bsm/component";
import React from "react";

const ContractUserDetailsContainer = React.lazy(() => import('./containers/ContractUserDetailsContainer'))
export const ContractUserDetailsRoutes: Array<AppRouteProps> = [
    {
        path: 'contracts',
        title: 'Harea.User.Contracts.title',
        element: <ContractUserDetailsContainer />
    }
]